import script from "./SocialFundAgreementDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SocialFundAgreementDialog.vue?vue&type=script&setup=true&lang=js"

import "./SocialFundAgreementDialog.vue?vue&type=style&index=0&id=7f5582da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f5582da"]])

export default __exports__